import React from 'react';
import { TextField as TextFieldTPA, TextFieldProps } from 'wix-ui-tpa/cssVars';
import { classes, style } from './text-field.st.css';
import { useCommonsTranslate } from '~commons/hooks/use-commons-translate';

export const TextField: React.FC<TextFieldProps> = (props) => {
  const t = useCommonsTranslate();
  return (
    <TextFieldTPA
      {...props}
      clearButtonAriaLabel={t('clear-button.aria-label')}
      className={style(classes.root, props.className)}
      newErrorMessage
    />
  );
};
